import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Paper, IconButton, Box } from "@mui/material";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";

export function SortableRow({
  id,
  children,
}: React.PropsWithChildren<{ id: string }>) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  return (
    <Paper             // ✔︎ 카드 테두리 + 그림자
      ref={setNodeRef}
      elevation={isDragging ? 6 : 1}         // 드래그 중엔 조금 더 떠오르게
      sx={{
        p: 1.5,
        mb: 1,
        border: "1px solid",
        borderColor: isDragging ? "primary.main" : "grey.300",
        borderRadius: 1,
        bgcolor: isDragging ? "grey.100" : "background.paper",
        transform: CSS.Transform.toString(transform),
        transition,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        cursor: isDragging ? "grabbing" : "grab",
      }}
    >
      {/* � 드래그 핸들 – 클릭 영역 명확 */}
      <IconButton
        {...listeners}
        {...attributes}
        sx={{
          cursor: "inherit",
          color: "text.secondary",
        }}
      >
        <DragIndicatorIcon />
      </IconButton>

      {/* � 실제 행 콘텐츠 */}
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
    </Paper>
  );
}
